import './App.css';
import { FormConfigContext } from './FormConfigContext';
import OrderForm from './pages/OrderForm/OrderForm';
import React, { createContext, useContext } from 'react';
import config from "./AppConfig.json"

function App() {
  const path = window.location.pathname.toLowerCase();
  let formConfig = config.defaultFormConfig;
  if(config.customFormPaths[path])
    formConfig = Object.assign(formConfig,config.customFormPaths[path]);

  return (
    <div className="container" >
      <FormConfigContext.Provider value={formConfig}>
        <OrderForm />
      </FormConfigContext.Provider>
    </div>
  );
}

export default App;
